import request from "../../util/request";

export function uploadFile(model) {
    let file = model.file;
    delete model.file;
    return request({
        url: '/api-file/upload',
        method: 'post',
        data: file,
        query: model,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}